export const articles = [
  {
    id: '1',
    title: '某顶流男星深夜密会神秘女子，酒店共度八小时，疑似新恋情曝光',
    slug: 'top-star-secret-date',
    excerpt: '据知情人士爆料，某当红顶流男星近日被拍到深夜与一名神秘女子先后进入某五星级酒店，直到次日清晨才分别离开，引发网友热议。',
    content: `<p>近日，娱乐圈再爆重磅消息。据知情人士向吃瓜网独家爆料，某当红顶流男星近日被拍到深夜与一名神秘女子先后进入某五星级酒店，直到次日清晨才分别离开。</p>
<p>据目击者描述，当晚约11点左右，该男星戴着黑色口罩和棒球帽，身穿休闲装低调现身酒店地下车库。约半小时后，一名身着白色连衣裙的长发女子也出现在同一地点，两人似乎在刻意保持距离。</p>
<p>更令人震惊的是，直到第二天早上七点左右，该男星才独自驾车离开酒店。而那名神秘女子则在半小时后由助理接走。整个过程中两人都没有同框出现，但时间线的高度重合让网友纷纷猜测这是刻意安排的"秘密约会"。</p>
<p>该男星此前一直以单身人设示人，粉丝群体庞大。消息传出后，粉丝反应两极分化：有人表示"尊重偶像私生活"，也有人直言"人设崩塌"。</p>
<p>目前，该男星的工作室尚未对此事做出回应。吃瓜网将持续关注事件进展。</p>`,
    category: 'mingxing-bagua',
    author: '吃瓜小编',
    publishDate: '2026-08-05',
    readCount: 128500,
    commentCount: 3621,
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20atmosphere%20with%20a%20luxury%20hotel%20entrance%20at%20night%2C%20paparazzi%20style%20photography%2C%20warm%20orange%20and%20dark%20tones%2C%20dramatic%20lighting%2C%20celebrity%20gossip%20vibe%2C%20cinematic%20composition%2C%20soft%20bokeh%20background%20with%20city%20lights&width=800&height=500&seq=article-01&orientation=landscape',
    tags: ['顶流男星', '恋情曝光', '秘密约会', '酒店'],
    featured: true,
    trending: true,
  },
  {
    id: '2',
    title: '知名女星离婚内幕曝光：第三者竟是圈内闺蜜，八年友情彻底破裂',
    slug: 'actress-divorce-scandal',
    excerpt: '娱乐圈再爆婚变！某知名女星离婚的真正原因浮出水面，背后竟涉及闺蜜背叛的狗血剧情，网友直呼"比电视剧还精彩"。',
    content: `<p>娱乐圈的婚姻向来脆弱，但这次的故事却让所有人始料未及。某知名女星近日正式宣布离婚，官方声明称"性格不合"，但吃瓜网独家获悉，事情远没有这么简单。</p>
<p>据与该女星关系密切的圈内人士透露，导致这段婚姻破裂的真正原因是该女星发现了丈夫与自己相识八年的圈内闺蜜之间的暧昧关系。更令人唏嘘的是，这位闺蜜正是当初介绍两人认识的"媒人"。</p>
<p>"她是在一次偶然的机会翻看丈夫手机时发现的，"知情人士表示，"那些聊天记录简直不堪入目，她当场就崩溃了。"</p>
<p>这位女星在圈内一直以好口碑著称，与这位闺蜜更是被称为"娱乐圈最铁姐妹花"。两人不仅经常在社交媒体上互动，还合作过多部作品，甚至在公开场合多次表示"比亲姐妹还亲"。</p>
<p>事发后，该女星已经将这位闺蜜的所有社交媒体取关，并删除了所有相关合照。而这位闺蜜的社交账号也已设为私密，暂未对此事做出任何回应。</p>
<p>网友对此事件反应强烈，纷纷表示"防火防盗防闺蜜"这句话再次得到印证。你怎么看这件事？</p>`,
    category: 'mingxing-bagua',
    author: '吃瓜小编',
    publishDate: '2026-08-04',
    readCount: 256800,
    commentCount: 8921,
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20of%20two%20women%20in%20conflict%2C%20one%20in%20tears%2C%20luxury%20apartment%20setting%2C%20warm%20golden%20hour%20lighting%2C%20emotional%20atmosphere%2C%20cinematic%20photography%2C%20soft%20focus%2C%20elegant%20interior%20design&width=800&height=500&seq=article-02&orientation=landscape',
    tags: ['知名女星', '离婚内幕', '闺蜜背叛', '婚变'],
    featured: true,
    trending: true,
  },
  {
    id: '3',
    title: '某选秀节目黑幕曝光：导师私下收钱保送学员，节目组紧急回应',
    slug: 'talent-show-scandal',
    excerpt: '一档热门选秀节目被爆存在严重黑幕，有导师涉嫌私下收取学员好处费，以保送其晋级。消息一出，舆论哗然。',
    content: `<p>选秀节目的公平性再次遭到质疑。近日，一位自称是某热门选秀节目前工作人员的网友在社交平台发布长文，揭露了节目录制过程中存在的种种黑幕。</p>
<p>根据该爆料者的描述，节目中的某位导师与部分学员存在不正当的利益关系。该导师以"指导"为名，私下收取高额"培训费"，承诺帮助学员在节目中走得更远。</p>
<p>"有些学员的唱功明明很一般，但每次都能莫名其妙地晋级，原因就在于此，"该爆料者写道，"导师会在评分环节给这些学员打高分，甚至在淘汰环节力保他们。"</p>
<p>此外，该爆料还提到节目组的剪辑也存在严重问题，会刻意塑造某些学员的"人设"，引导观众投票方向。</p>
<p>对此，节目组在今日凌晨紧急发布声明，称"相关爆料纯属捏造，恶意诽谤"，并表示已委托律师处理。但网友们似乎并不买账，纷纷要求节目组公开投票数据和评分细节。</p>
<p>目前，涉事导师尚未对此事进行回应。吃瓜网将持续跟进。</p>`,
    category: 'yingshi-zongyi',
    author: '吃瓜特派员',
    publishDate: '2026-08-04',
    readCount: 189200,
    commentCount: 5621,
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20theater%20stage%20with%20spotlight%2C%20dramatic%20shadows%2C%20one%20figure%20standing%20center%20stage%2C%20mysterious%20atmosphere%2C%20warm%20amber%20spotlight%2C%20behind%20the%20scenes%20vibe%2C%20cinematic%20composition&width=800&height=500&seq=article-03&orientation=landscape',
    tags: ['选秀节目', '黑幕', '导师', '节目组回应'],
    featured: false,
    trending: true,
  },
  {
    id: '4',
    title: '千万粉丝网红偷税漏税被查，补缴金额惊人，账号已被限制功能',
    slug: 'influencer-tax-evasion',
    excerpt: '又一大网红翻车！拥有千万粉丝的某头部网红因偷税漏税被税务部门查处，补缴税款及罚款总额令人咋舌。',
    content: `<p>网红圈的税务问题再次成为焦点。据相关部门通报，某拥有超过千万粉丝的头部网红因涉嫌偷逃税款被依法查处。</p>
<p>通报显示，该网红在2023年至2025年期间，通过隐匿直播打赏收入、虚假申报等方式，共计少缴个人所得税及增值税超过3000万元。税务机关已依法对其追缴税款、加收滞纳金并处以罚款，合计金额超过5000万元。</p>
<p>该网红此前以"接地气""真性情"的人设走红，带货能力极强，单场直播销售额最高曾突破2亿元。然而，此次税务风波让他的形象一落千丈。</p>
<p>目前，该网红的多个社交平台账号已被限制部分功能，部分品牌方也已宣布与其解约。业内人士分析，此次事件对该网红的职业生涯将是致命打击。</p>
<p>税务部门同时提醒广大网络主播和自媒体从业者，要依法诚信纳税，不要心存侥幸。据悉，这已是今年第四起因税务问题被查处的网红案例。</p>`,
    category: 'wanghong-baoliao',
    author: '吃瓜编辑部',
    publishDate: '2026-08-03',
    readCount: 312000,
    commentCount: 12450,
    image: 'https://readdy.ai/api/search-image?query=A%20luxurious%20office%20with%20stacks%20of%20money%20on%20a%20desk%2C%20dramatic%20lighting%20from%20a%20window%2C%20dark%20shadows%2C%20tax%20documents%20scattered%2C%20cinematic%20mood%2C%20warm%20golden%20and%20dark%20tones&width=800&height=500&seq=article-04&orientation=landscape',
    tags: ['网红', '偷税漏税', '千万粉丝', '账号被封'],
    featured: true,
    trending: true,
  },
  {
    id: '5',
    title: '某热播剧男女主角因戏生情，片场亲密互动被拍，两人均已单身',
    slug: 'drama-couple-romance',
    excerpt: '又一对荧幕情侣成真！某热播剧男女主角被拍到在片场和私下频繁互动，甜蜜细节曝光，粉丝集体狂欢。',
    content: `<p>荧幕情侣变真情侣，这大概是CP粉最喜闻乐见的剧情了。近日，某正在热播的都市情感剧的男女主角被拍到大量亲密互动画面，两人疑似已经假戏真做。</p>
<p>据片场工作人员透露，两人在拍摄期间就互动频繁，经常在休息时间单独相处。更有目击者拍到两人在收工后一起吃饭、逛街的画面，行为举止十分亲密。</p>
<p>"他们在片场的化学反应太强了，导演都说很少见到这么自然的对手戏，"一位剧组工作人员表示，"当时我们就觉得这两人之间肯定有事。"</p>
<p>值得注意的是，两人目前都处于单身状态。男主角去年刚刚结束一段恋情，而女主角则一直表示"以事业为重"。如果两人的恋情属实，这将是今年娱乐圈最甜的瓜之一。</p>
<p>目前，两人的工作室均未对此做出回应，但双方粉丝已经在社交媒体上"狂欢"，CP粉更是直呼"过年了"。该剧的收视率也因此一路飙升，可谓双赢。</p>`,
    category: 'yingshi-zongyi',
    author: '吃瓜小编',
    publishDate: '2026-08-03',
    readCount: 167300,
    commentCount: 4321,
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20scene%20on%20a%20film%20set%2C%20two%20actors%20sitting%20close%20together%20between%20takes%2C%20warm%20sunset%20lighting%2C%20camera%20equipment%20in%20background%2C%20soft%20focus%2C%20beautiful%20cinematic%20photography%2C%20natural%20and%20intimate&width=800&height=500&seq=article-05&orientation=landscape',
    tags: ['热播剧', '因戏生情', '荧幕情侣', '片场互动'],
    featured: false,
    trending: true,
  },
  {
    id: '6',
    title: '某奢侈品牌代言人突然被换，知情人称涉及敏感言论，品牌方火速切割',
    slug: 'brand-ambassador-dropped',
    excerpt: '国际奢侈品牌连夜更换中国区代言人，据传与该艺人此前的敏感言论有关。品牌方的迅速反应引发业内关注。',
    content: `<p>品牌代言人的更换本是正常的商业操作，但这次却显得有些不同寻常。某国际奢侈品牌在今日凌晨突然宣布更换中国区代言人，而距离该代言人上任才不到三个月。</p>
<p>根据品牌方发布的简短声明，更换原因是"战略调整"，但业内人士透露，真正的原因与该代言人此前在社交媒体上的一些敏感言论有关。虽然这些言论已经被删除，但仍有网友截图保存。</p>
<p>"品牌方得知此事后非常重视，几乎是连夜开会做出了这个决定，"一位与品牌方关系密切的人士透露，"对于奢侈品牌来说，代言人的形象就是品牌的形象，他们不能冒任何风险。"</p>
<p>新代言人已经确定为另一位口碑良好的实力派演员。品牌方的快速反应被业内称为"教科书级别的危机公关"。</p>
<p>而被换掉的艺人目前尚未对此事发表任何评论。其工作室仅表示"尊重品牌方的决定"，未做更多说明。该艺人的其他代言是否也会受到影响，目前尚不清楚。</p>`,
    category: 'shishang-chaoliu',
    author: '吃瓜小编',
    publishDate: '2026-08-02',
    readCount: 143200,
    commentCount: 3891,
    image: 'https://readdy.ai/api/search-image?query=A%20luxury%20brand%20billboard%20being%20taken%20down%20at%20night%2C%20dramatic%20lighting%2C%20urban%20shopping%20district%2C%20workers%20on%20ladder%2C%20cinematic%20atmosphere%2C%20warm%20street%20lights%20and%20dark%20shadows&width=800&height=500&seq=article-06&orientation=landscape',
    tags: ['奢侈品牌', '代言人被换', '敏感言论', '危机公关'],
    featured: false,
    trending: false,
  },
  {
    id: '7',
    title: '独家：某知名导演被曝片场霸凌新人演员，多名演员含泪控诉',
    slug: 'director-bullying-scandal',
    excerpt: '吃瓜网独家获悉，某知名导演在片场存在长期霸凌新人演员的行为，多位曾与其合作的演员勇敢发声，揭露真相。',
    content: `<p>在光鲜亮丽的影视圈背后，隐藏着多少不为人知的黑暗？吃瓜网经过长达一个月的调查采访，独家揭露某知名导演在片场长期霸凌新人演员的恶劣行为。</p>
<p>多名曾与该导演合作过的演员在接受采访时表示，该导演在片场脾气暴躁，经常对新人演员进行言语辱骂，甚至有过肢体推搡的行为。"他会当着全组人的面骂你，用最难听的话，让你完全丧失自信，"一位不愿透露姓名的演员含泪说道。</p>
<p>另一位演员表示，该导演尤其针对没有背景的新人。"如果你是新人，又没有经纪公司的背景，他就会把你当出气筒。有好几个新人演员因为受不了他的辱骂，拍到一半就退出了。"</p>
<p>令人震惊的是，该导演在业内拥有极高的地位，作品多次获奖。正因如此，很多受害者选择了忍气吞声，不敢发声。</p>
<p>目前，该导演尚未对此事做出回应。但有消息称，其正在筹备的新项目已经有多位演员表示拒绝参加。业内人士呼吁，影视行业需要建立更完善的权益保护机制。</p>`,
    category: 'dujia-mengliao',
    author: '吃瓜调查组',
    publishDate: '2026-08-02',
    readCount: 98200,
    commentCount: 5678,
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20film%20set%20with%20a%20director%20chair%20in%20spotlight%2C%20silhouette%20of%20a%20figure%2C%20dramatic%20shadows%2C%20film%20equipment%20around%2C%20tense%20atmosphere%2C%20cinematic%20photography%2C%20high%20contrast%2C%20warm%20and%20dark%20tones&width=800&height=500&seq=article-07&orientation=landscape',
    tags: ['知名导演', '片场霸凌', '新人演员', '独家爆料'],
    featured: false,
    trending: true,
  },
  {
    id: '8',
    title: '娱乐圈最贵离婚案尘埃落定，财产分割细节曝光，女方获天价补偿',
    slug: 'expensive-divorce-settlement',
    excerpt: '一场持续两年多的离婚官司终于画上句号。财产分割结果令外界咋舌，女方获得的补偿金额创下娱乐圈新纪录。',
    content: `<p>被称为"娱乐圈最贵离婚案"的某明星夫妻离婚官司终于尘埃落定。经过两年多的拉锯战，双方最终在法院调解下达成协议。</p>
<p>根据知情人士透露的财产分割细节，女方获得了包括多处豪宅、豪车以及数亿现金在内的巨额补偿，总价值被估超过8亿元，创下娱乐圈离婚案的新纪录。</p>
<p>这对夫妻结婚十五年，育有两个孩子。男方在娱乐圈摸爬滚打多年，积累了巨额财富，涉及影视投资、房地产等多个领域。而女方在婚后基本淡出娱乐圈，专心相夫教子。</p>
<p>此次离婚案的焦点在于男方的部分隐性资产，包括境外投资和代持股份等。女方的律师团队经过大量调查取证，最终成功将这部分资产纳入分割范围。</p>
<p>目前，双方均未对财产分割结果发表公开评论。据接近女方的朋友透露，她对这个结果"还算满意"，未来可能会带着孩子移居海外开始新生活。</p>`,
    category: 'mingxing-bagua',
    author: '吃瓜编辑部',
    publishDate: '2026-08-01',
    readCount: 275000,
    commentCount: 9876,
    image: 'https://readdy.ai/api/search-image?query=A%20luxury%20mansion%20with%20moving%20trucks%20outside%2C%20golden%20sunset%20light%2C%20elegant%20architecture%2C%20bittersweet%20atmosphere%2C%20cinematic%20photography%2C%20warm%20and%20melancholic%20tones%2C%20high%20end%20residential%20area&width=800&height=500&seq=article-08&orientation=landscape',
    tags: ['离婚案', '财产分割', '天价补偿', '娱乐圈'],
    featured: true,
    trending: false,
  },
  {
    id: '9',
    title: '短视频平台两大顶流主播互撕，直播间隔空对骂，粉丝掀起骂战',
    slug: 'streamers-feud',
    excerpt: '某短视频平台两大头部主播因带货资源之争爆发激烈冲突，在各自的直播间隔空互怼，场面一度失控。',
    content: `<p>网红圈的竞争向来激烈，但发展到公开互撕的地步还是让人大开眼界。近日，某短视频平台两大顶流主播因为品牌代言资源之争，在各自的直播间爆发了激烈冲突。</p>
<p>事情的起因是某国际美妆品牌的新品代言。据传该品牌原本打算与主播A合作，但最终选择了主播B。主播A在直播中含沙射影地表示有人"抢资源"、"背后使手段"，虽然没有点名，但明眼人都知道说的是谁。</p>
<p>主播B随即在自己的直播中回应，称"某些人自己能力不行就别怪别人"，并暗示对方"数据造假"。双方的言论迅速在粉丝群中传播，引发了两家粉丝之间的激烈骂战。</p>
<p>平台方在事件发酵后紧急介入，对双方的直播内容进行了审核，并对部分违规内容进行了下架处理。但双方粉丝在社交媒体上的骂战仍在持续。</p>
<p>业内人士分析，这背后反映的是直播带货行业日益激烈的竞争态势。随着流量红利见顶，头部主播之间的资源争夺将越来越白热化。</p>`,
    category: 'wanghong-baoliao',
    author: '吃瓜小编',
    publishDate: '2026-08-01',
    readCount: 231000,
    commentCount: 15234,
    image: 'https://readdy.ai/api/search-image?query=A%20split%20screen%20showing%20two%20live%20streaming%20rooms%20with%20intense%20expressions%2C%20bright%20colorful%20streaming%20setup%2C%20dramatic%20red%20and%20warm%20lighting%2C%20competitive%20atmosphere%2C%20modern%20gaming%20studio%20setup&width=800&height=500&seq=article-09&orientation=landscape',
    tags: ['顶流主播', '互撕', '直播间', '粉丝骂战'],
    featured: false,
    trending: true,
  },
  {
    id: '10',
    title: '某女星红毯造型翻车，网友吐槽"像裹了窗帘布"，设计师回应引争议',
    slug: 'red-carpet-fashion-fail',
    excerpt: '在某颁奖典礼红毯上，一位女星的造型引发全网吐槽。网友脑洞大开的评论让人忍俊不禁，而设计师的回应更是火上浇油。',
    content: `<p>红毯向来是明星们争奇斗艳的战场，也是"翻车"的高发地带。在昨晚举行的某颁奖典礼上，一位以时尚品味著称的女星却在红毯上遭遇了职业生涯最大的造型危机。</p>
<p>该女星身着一件由某知名设计师定制的礼服亮相，本意是想展现"前卫艺术"的风格。然而，这件礼服的夸张设计却被网友无情吐槽。有人评论"像裹了一床窗帘布出门"，还有人调侃"这是把家里的沙发套穿来了吗"，脑洞大开的评论迅速在社交媒体上刷屏。</p>
<p>更让人意外的是，设计师在看到网友的评论后发布了一条回应："不懂时尚的人不配评论我的作品。"这番言论引发了更大的争议，不少时尚博主也站出来批评该设计确实存在问题。</p>
<p>该女星在活动结束后并未对造型争议做出回应，但有粉丝发现她在社交媒体上点赞了一条"设计师应该听取大众意见"的帖子，被认为是在委婉表达自己的态度。</p>
<p>时尚评论人指出，明星红毯造型不仅要考虑设计感，更要考虑大众审美。过于"曲高和寡"的设计反而容易适得其反。</p>`,
    category: 'shishang-chaoliu',
    author: '吃瓜小编',
    publishDate: '2026-07-31',
    readCount: 198000,
    commentCount: 7234,
    image: 'https://readdy.ai/api/search-image?query=A%20red%20carpet%20event%20with%20a%20female%20celebrity%20in%20an%20unusual%20dramatic%20dress%2C%20photographers%20flashing%20cameras%2C%20glamorous%20event%20setting%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20luxurious%20atmosphere&width=800&height=500&seq=article-10&orientation=landscape',
    tags: ['红毯造型', '翻车', '网友吐槽', '设计师'],
    featured: false,
    trending: false,
  },
  {
    id: '11',
    title: '某综艺节目录制现场发生意外，嘉宾受伤送医，节目组被指安全措施不到位',
    slug: 'variety-show-accident',
    excerpt: '一起综艺节目录制事故引发关注。某嘉宾在完成挑战任务时意外受伤，被紧急送往医院。节目组的安全问题再次被推上风口浪尖。',
    content: `<p>综艺节目为了追求刺激和收视率，往往会设计一些高难度的挑战环节。但当"刺激"变成"危险"，问题就严重了。</p>
<p>据现场观众爆料，在某热门综艺节目的录制过程中，一位嘉宾在完成高空挑战任务时，安全绳突然出现故障，导致该嘉宾从约三米高处跌落。虽然下方有防护垫，但该嘉宾仍然受了伤，被紧急送往附近医院。</p>
<p>目击者称，事故发生后现场一度混乱，录制被迫中断。其他嘉宾也都受到了不同程度的惊吓，有人当场落泪。</p>
<p>节目组在事发后发布了声明，称该嘉宾"目前情况稳定，正在接受进一步检查"，并表示将"全面排查安全隐患"。但网友们并不买账，纷纷指责节目组为了收视率不顾嘉宾安全。</p>
<p>这也并非该节目第一次出现安全问题。此前就有观众反映节目中的某些环节"看着就危险"。业内人士呼吁，综艺节目在追求效果的同时，必须将安全放在首位。</p>`,
    category: 'yingshi-zongyi',
    author: '吃瓜小编',
    publishDate: '2026-07-31',
    readCount: 176000,
    commentCount: 6543,
    image: 'https://readdy.ai/api/search-image?query=A%20television%20studio%20set%20with%20emergency%20vehicles%20outside%2C%20dramatic%20red%20and%20blue%20lights%2C%20worried%20crowd%2C%20production%20equipment%2C%20tense%20atmosphere%2C%20cinematic%20photography%2C%20warm%20and%20urgent%20mood&width=800&height=500&seq=article-11&orientation=landscape',
    tags: ['综艺节目', '录制事故', '嘉宾受伤', '安全问题'],
    featured: false,
    trending: false,
  },
  {
    id: '12',
    title: '独家深度：娱乐圈"潜规则"产业链调查，新人入行的残酷真相',
    slug: 'entertainment-industry-investigation',
    excerpt: '吃瓜网历时三个月深入调查，揭开娱乐圈光鲜外表下的灰色产业链。多位业内人士匿名接受采访，讲述不为人知的行业真相。',
    content: `<p>娱乐圈的光环吸引着无数年轻人前赴后继地想要进入这个行业。但在鲜花和掌声背后，隐藏着多少不为人知的灰色地带？吃瓜网调查组历时三个月，采访了二十余位业内人士，试图还原一个真实的娱乐圈。</p>
<p>"如果你没有背景、没有资源，想要在这个圈子出头，几乎是天方夜谭。"一位在圈内摸爬滚打了十年的经纪人告诉记者，"很多人以为只要长得好看、有才华就能成功，但实际上这些远远不够。"</p>
<p>调查发现，从选角、签约到宣传推广，整个产业链中存在着大量的灰色操作。有些经纪公司会以"培训"为名收取高额费用，但提供的培训质量却令人堪忧。有些剧组在选角时存在明显的利益输送，角色早已内定。</p>
<p>更令人担忧的是，一些不法分子利用年轻人想成名的心理，以"介绍资源""包装推广"为诱饵实施诈骗。据不完全统计，仅去年一年，全国就有超过500起此类诈骗案件。</p>
<p>多位受访者呼吁，娱乐行业需要更加透明和规范的管理机制，为真正有才华的年轻人提供公平的竞争环境。</p>`,
    category: 'dujia-mengliao',
    author: '吃瓜调查组',
    publishDate: '2026-07-30',
    readCount: 345000,
    commentCount: 18765,
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20backstage%20area%20with%20a%20single%20spotlight%20on%20an%20empty%20chair%2C%20mysterious%20atmosphere%2C%20long%20shadows%2C%20cinematic%20noir%20style%2C%20warm%20accent%20light%2C%20theater%20behind%20the%20scenes%2C%20contemplative%20mood&width=800&height=500&seq=article-12&orientation=landscape',
    tags: ['娱乐圈', '潜规则', '产业调查', '独家深度'],
    featured: true,
    trending: true,
  },
  {
    id: '13',
    title: '某流量小生被曝学历造假，母校紧急回应，粉丝坚称"被黑"',
    slug: 'celebrity-degree-fraud',
    excerpt: '一位以"学霸"人设圈粉无数的流量小生被网友扒出学历存在问题，其毕业院校的真实性受到质疑，引发广泛讨论。',
    content: `<p>"学霸人设"在娱乐圈向来吃香，但一旦翻车，后果也相当严重。近日，一位以高学历著称的流量小生就遭遇了这样的危机。</p>
<p>事情源于一位网友在社交平台上的爆料。该网友声称经过调查发现，这位小生所宣称的"某知名大学硕士学历"存在严重问题——该校并没有该生的学籍记录，而该生晒出的毕业证书也被指出存在多处疑点。</p>
<p>消息一出，迅速登上热搜。该小生的粉丝立刻组织"辟谣"，声称这是"对家在黑"。但随着越来越多的细节被扒出，质疑声也越来越大。</p>
<p>该小生曾在多个采访中讲述自己的"留学经历"，甚至在综艺节目中用英语与外国嘉宾交流以证明自己的学历。如果学历造假属实，这些行为将变得更加讽刺。</p>
<p>对此，该小生所声称毕业的大学也发布了声明，表示"正在核实相关情况"。而该小生本人及其工作室目前保持沉默，尚未做出任何回应。</p>
<p>业内人士指出，明星树立"学霸"人设本无可厚非，但如果涉及造假，不仅会面临人设崩塌的风险，还可能涉及法律问题。</p>`,
    category: 'shehui-redian',
    author: '吃瓜小编',
    publishDate: '2026-07-30',
    readCount: 289000,
    commentCount: 11234,
    image: 'https://readdy.ai/api/search-image?query=A%20university%20diploma%20on%20a%20desk%20with%20a%20magnifying%20glass%2C%20investigative%20atmosphere%2C%20warm%20desk%20lamp%20light%2C%20dark%20background%2C%20mysterious%20mood%2C%20cinematic%20closeup%2C%20dramatic%20shadows&width=800&height=500&seq=article-13&orientation=landscape',
    tags: ['流量小生', '学历造假', '学霸人设', '母校回应'],
    featured: false,
    trending: true,
  },
  {
    id: '14',
    title: '某知名歌手新歌涉嫌抄袭，旋律高度雷同国外歌曲，制作人回应争议',
    slug: 'song-plagiarism-accusation',
    excerpt: '一位知名歌手发布的新歌被指旋律与某国外热门单曲"惊人相似"，乐评人和网友纷纷对比，抄袭疑云笼罩。',
    content: `<p>音乐圈又现"抄袭"争议。某知名歌手近日发布的新歌在上线不到24小时就被网友指出旋律与一首三年前发行的国外热门单曲高度相似。</p>
<p>有网友将两首歌的旋律进行了详细的对比分析，发现副歌部分的和弦进行几乎一模一样，甚至连编曲风格都极为接近。"这已经不是借鉴的范畴了，简直就像是直接翻译过来的，"一位音乐制作人在社交平台上评论道。</p>
<p>该歌手的粉丝则坚决否认抄袭，认为"流行音乐的旋律就那么多，撞旋律很正常"。但也有不少中立网友表示，两首歌的相似度"确实有点高"。</p>
<p>面对争议，该歌曲的制作人在社交平台发文回应："音乐创作中难免会受其他作品的影响，但我们没有抄袭。如果大家觉得有相似之处，那可能是潜意识中的影响，我们对此表示歉意。"</p>
<p>然而，这番回应被网友解读为"变相承认"，争议反而进一步升级。原作者方面目前尚未做出回应，但据传其版权代理公司已经开始关注此事。</p>`,
    category: 'yingshi-zongyi',
    author: '吃瓜小编',
    publishDate: '2026-07-29',
    readCount: 156000,
    commentCount: 5432,
    image: 'https://readdy.ai/api/search-image?query=A%20music%20studio%20with%20two%20sheet%20music%20pages%20side%20by%20side%2C%20one%20highlighted%2C%20warm%20studio%20lighting%2C%20musical%20instruments%20in%20background%2C%20tense%20comparison%20mood%2C%20cinematic%20photography&width=800&height=500&seq=article-14&orientation=landscape',
    tags: ['知名歌手', '涉嫌抄袭', '新歌', '旋律雷同'],
    featured: false,
    trending: false,
  },
  {
    id: '15',
    title: '某女星宣布退出娱乐圈，长文告别信曝光，圈内好友纷纷留言祝福',
    slug: 'actress-retires',
    excerpt: '又一位实力派女星选择告别演艺圈。她在社交媒体发布长文，回顾了自己的演艺生涯，真情流露令人动容。',
    content: `<p>告别总是令人伤感。今天下午，一位深受观众喜爱的实力派女星在社交媒体发布长文，正式宣布退出娱乐圈，结束了自己长达二十年的演艺生涯。</p>
<p>在这篇饱含深情的告别信中，她回顾了自己从艺二十年的心路历程：从默默无闻的小配角到收获无数奖项的实力派演员，每一步都走得艰辛而踏实。</p>
<p>"感谢这个舞台给了我实现梦想的机会，也感谢每一位支持过我的观众和粉丝，"她在信中写道，"二十年了，我觉得是时候开启人生的新篇章了。这不是结束，而是一个新的开始。"</p>
<p>据接近她的朋友透露，她其实早在两年前就已经有了退圈的想法，只是一直没有找到合适的时机。"她不是一时冲动，而是深思熟虑了很久。她想去读书、旅行，过一种完全不同的生活。"</p>
<p>消息传出后，圈内众多好友纷纷在评论区留言祝福。她的最后一部作品将于下月上映，这将成为她送给观众的"告别礼物"。</p>`,
    category: 'mingxing-bagua',
    author: '吃瓜小编',
    publishDate: '2026-07-29',
    readCount: 201000,
    commentCount: 8765,
    image: 'https://readdy.ai/api/search-image?query=A%20female%20actor%20bowing%20on%20an%20empty%20stage%20with%20a%20single%20spotlight%2C%20bittersweet%20farewell%20atmosphere%2C%20warm%20golden%20light%2C%20theater%20curtains%2C%20emotional%20and%20elegant%2C%20cinematic%20photography&width=800&height=500&seq=article-15&orientation=landscape',
    tags: ['女星', '退出娱乐圈', '告别信', '演艺生涯'],
    featured: false,
    trending: false,
  },
  {
    id: '16',
    title: '年度最受期待电影阵容曝光，超豪华卡司引热议，导演放话"票房要破纪录"',
    slug: 'blockbuster-movie-cast',
    excerpt: '备受瞩目的年度大片终于揭开神秘面纱。十位一线明星的豪华阵容让网友直呼"神仙打架"，导演更是放出豪言。',
    content: `<p>今天上午，备受瞩目的年度大片《星辰之海》在北京举行了盛大的发布会，正式公布了全明星阵容。十位一线演员的同框让现场媒体和粉丝惊呼不已。</p>
<p>据悉，该片投资超过5亿元，汇聚了华语影坛最具票房号召力的演员阵容。影片讲述了在未来世界背景下，一群来自不同背景的英雄共同守护人类最后希望的故事。</p>
<p>导演在发布会上信心满满地表示："我们花了三年时间筹备这部电影，从剧本到特效都是顶级水准。我相信它不仅会打破票房纪录，更会成为中国科幻电影的里程碑。"</p>
<p>影片定档明年春节档，这一选择也显示出片方对影片质量的高度自信——春节档向来是兵家必争之地，竞争异常激烈。业内人士分析，以目前的阵容和市场热度来看，该片票房有望突破40亿。</p>
<p>发布会结束后，相关话题迅速登上热搜，网友纷纷表示"这个阵容不看不行的程度"。你最期待哪位演员的表现？</p>`,
    category: 'yingshi-zongyi',
    author: '吃瓜特派员',
    publishDate: '2026-07-28',
    readCount: 223000,
    commentCount: 6789,
    image: 'https://readdy.ai/api/search-image?query=A%20grand%20movie%20press%20conference%20with%20ten%20actors%20standing%20on%20stage%2C%20dramatic%20spotlights%2C%20cinematic%20movie%20poster%20background%2C%20epic%20atmosphere%2C%20warm%20golden%20lighting%2C%20hollywood%20style%20event&width=800&height=500&seq=article-16&orientation=landscape',
    tags: ['年度大片', '豪华阵容', '发布会', '票房纪录'],
    featured: false,
    trending: true,
  },
];

export type Article = typeof articles[number];